import { cn } from "utils";
import BadgeScore from "./components/BadgeScore";
import Header from "./components/Header/Header";
import RankDetails from "./components/RankDetails";

const Layout = ({ children, rankDetails }) => (
  <div
    className={cn(
      "match-agent-card relative w-full bg-white rounded-lg text-[#334155] p-8 flex flex-col gap-4",
      {
        "animate-pulse opacity-75": Object.keys(rankDetails || {}).length === 0,
      }
    )}
    data-component="match-agent-card"
    data-score={rankDetails.score}
    data-position={rankDetails?.content?.current_role}
  >
    {children}
  </div>
);

const HitCard = ({ hit, collectionKey, activeTabName }) => {
  return (
    <Layout rankDetails={hit?.rankDetails ?? {}}>
      <BadgeScore {...hit?.rankDetails} />

      <Header
        hit={hit}
        collectionKey={collectionKey}
        activeTabName={activeTabName}
      />
      <RankDetails {...hit.rankDetails} />
    </Layout>
  );
};

export default HitCard;
